import { useContext } from 'react';
import { UserContext } from '../../contexts/user-context';
import { useVenturesContext } from '../../contexts/ventures-context';
import ConfirmModal from '../common/confirm-modal';

function ProfileUpdateModal() {
  const { hasAccessToAction } = useContext(UserContext);
  const {
    isSendingProfileUpdate,
    profileUpdateTargetVentureIds,
    sendVentureUpdate,
    setProfileUpdateTargetVentureIds,
  } = useVenturesContext();

  return hasAccessToAction('venture.updateProfile') ? (
    <ConfirmModal
      isOpen={!!profileUpdateTargetVentureIds}
      onClose={() => setProfileUpdateTargetVentureIds(null)}
      title='Send Single Profile Update Request'
      loading={isSendingProfileUpdate}
      body='Your are about to send a temporary link to allow participants to update their profile. The link can work only 1 time, and is available for 48 hours only.'
      successProps={{
        btnLabel: 'Ok',
        onSuccess: sendVentureUpdate,
      }}
      cancelProps={{
        btnLabel: 'Cancel',
      }}
    />
  ) : null;
}

export default ProfileUpdateModal;
